<template>
    <article class="page page-contact">
        <nav v-if="$root.mobileDetected" class="page-contact-nav">
            <h1 class="page-contact-nav-title">Contact</h1>
            <router-link to="/" class="page-contact-nav-goback">Close</router-link>
        </nav>
        <div class="page-contact__track">
            <div ref="canvas-container" class="page-contact-canvas-container"></div>
            <div v-if="contacts" class="page-contact-body">
                <div class="page-contact-body-links">
                    <p
                        v-for="(link, index) in contacts.links"
                        :key="index"
                        class="page-contact-body-links-item"
                    >
                        <a :href="(link.type === 'mail' ? 'mailto:' : link.type === 'phone' ? 'tel:' : '') + link.href" class="page-contact-body-links-item-link">{{ link.label }}</a>
                    </p>
                </div>
                <div class="page-contact-body-members">
                    <div 
                        v-for="(member, index) in contacts.members"
                        :key="index"
                        class="page-contact-body-members-item"
                    >
                        <p class="page-contact-body-members-item-fullname">{{ member.fullname }}</p>
                        <p class="page-contact-body-members-item-job">{{ member.job }}</p>
                        <p class="page-contact-body-members-item-mail">
                            <a :href="'mailto:' + member.mail">{{ member.mail }}</a>
                        </p>
                    </div>
                </div>
                <a v-if="$root.mobileDetected" class="page-contact-body-credit" href="https://www.feldman.studio" target="_blank">Website by <span>Feldman Studio</span></a>
            </div>
        </div>

        <svg v-if="!$root.mobileDetected" :class="['image__drag-and-drop', {hide: hasOnceDragged}]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77.42 28.53">
            <title>UBIQUITY-WEBSITE_DRAG&amp;amp;DROP_2020-06-04</title>
            <path class="cls-1" d="M15.25,24.63h1.38a1.78,1.78,0,0,1,1.95,1.93,1.77,1.77,0,0,1-1.95,1.91H15.25ZM18,26.56a1.32,1.32,0,0,0-1.4-1.49h-.84v3h.84A1.31,1.31,0,0,0,18,26.56Z"/>
            <path class="cls-1" d="M20.36,24.63H22c.81,0,1.27.42,1.27,1.16a1.08,1.08,0,0,1-1.08,1.12l1.23,1.56h-.64L21.57,27H20.9v1.52h-.54Zm.54.44v1.44h1c.52,0,.83-.26.83-.72s-.28-.72-.83-.72Z"/>
            <path class="cls-1" d="M27.29,27.44H25.51l-.41,1h-.52l1.56-3.84h.54l1.56,3.84h-.55ZM27.11,27,26.4,25.2,25.69,27Z"/>
            <path class="cls-1" d="M31.24,24.57a1.57,1.57,0,0,1,1.68,1.22l-.52.11A1.09,1.09,0,0,0,31.24,25c-.86,0-1.34.58-1.34,1.53s.48,1.54,1.31,1.54A1.15,1.15,0,0,0,32.48,27H31.2v-.42H33v1.93H32.6l-.05-.71a1.46,1.46,0,0,1-1.39.77,1.78,1.78,0,0,1-1.81-2A1.81,1.81,0,0,1,31.24,24.57Z"/>
            <path class="cls-1" d="M36.65,27.51c0-.44.24-.75.87-1.05l0,0c-.43-.4-.54-.63-.54-.93,0-.56.44-.94,1.11-.94s1.11.36,1.11.92-.23.71-.89,1h0l.93.84a2,2,0,0,0,.24-.79l.51.05a2.23,2.23,0,0,1-.39,1.08l.83.75h-.65l-.47-.42a1.94,1.94,0,0,1-1.33.48C37.13,28.53,36.65,28.11,36.65,27.51Zm1.38.6a1.32,1.32,0,0,0,.94-.36l-1.09-1,0,0c-.51.26-.65.44-.65.74S37.5,28.11,38,28.11ZM38,26.24l.08,0c.54-.27.68-.43.68-.71s-.23-.5-.61-.5a.54.54,0,0,0-.61.52C37.51,25.74,37.6,25.9,38,26.24Z"/>
            <path class="cls-1" d="M43.91,24.63h1.38a1.79,1.79,0,0,1,2,1.93,1.78,1.78,0,0,1-2,1.91H43.91Zm2.78,1.93a1.32,1.32,0,0,0-1.4-1.49h-.84v3h.84A1.31,1.31,0,0,0,46.69,26.56Z"/>
            <path class="cls-1" d="M49,24.63h1.64c.82,0,1.28.42,1.28,1.16a1.08,1.08,0,0,1-1.08,1.12l1.23,1.56h-.65L50.23,27h-.67v1.52H49Zm.54.44v1.44h1c.53,0,.83-.26.83-.72s-.28-.72-.83-.72Z"/>
            <path class="cls-1" d="M53.37,26.55a1.84,1.84,0,1,1,3.67,0,1.84,1.84,0,1,1-3.67,0Zm3.13,0c0-.92-.44-1.53-1.3-1.53s-1.28.61-1.28,1.53.43,1.53,1.28,1.53S56.5,27.47,56.5,26.55Z"/>
            <path class="cls-1" d="M58.82,24.63h1.53a1.28,1.28,0,1,1,0,2.56h-1v1.28h-.54Zm.54.44v1.67h.89a.79.79,0,0,0,.9-.82.8.8,0,0,0-.9-.85Z"/>
            <path class="cls-1" d="M38.69,0a3.44,3.44,0,0,0-3.44,3.44v4a3.44,3.44,0,0,0,6.88,0v-4A3.44,3.44,0,0,0,38.69,0Zm2.93,7.42a2.93,2.93,0,0,1-5.86,0v-4a2.93,2.93,0,0,1,5.86,0Z"/>
            <path class="cls-1" d="M38.69,2.36a.51.51,0,1,0,.51.51A.51.51,0,0,0,38.69,2.36Z"/>
            <path class="cls-1" d="M32.48,2.63C14.37,3.31,3.11,9.5,2.36,9.93L1.77,8.82,0,11.68l3.17-.22L2.6,10.37c.49-.28,11.7-6.57,29.91-7.24Z"/>
            <path class="cls-1" d="M77.42,11.66,75.65,8.8l-.59,1.11c-.75-.42-12-6.62-30.12-7.29l0,.49c18.21.68,29.42,7,29.91,7.25l-.58,1.08Z"/>
        </svg>

        <a v-if="!$root.mobileDetected" class="page-contact__credit" href="https://www.feldman.studio" target="_blank">Website by <span>Feldman Studio</span></a>
    </article>
</template>

<script>

// Data
import {contacts} from '../../__data'

// Scene
import SceneContact from '../../helpers/threejs/scenes/SceneContact'

// Component
import LayoutHeaderDesktop from '../layout/LayoutHeaderDesktop'

// Utils
import MyEmitter from '../../helpers/MyEmitter'
import params from '../../utils/params'
import Utils from '../../utils/utils'

// Lib
import gsap from "gsap"

export default {
    components: {
        LayoutHeaderDesktop
    },
    data: function(){
        return {
            contacts: null,
            hasOnceDragged: false
        }
    },
    name: "PageContact",
    beforeDestroy: function(){
        this.scene.destroy()
        this.scene = null
    },
    beforeRouteEnter(to, from, next){
        next(vm => {
            gsap.from(vm.$el, {
                duration: 1.2,
                opacity: 0
            })
        })
    },
    beforeRouteLeave(to, from, next){
        if(!this.$root.mobileDetected){
            
            // only on desktop
            gsap.to(this.$el, {
                duration: 1.2,
                onComplete: () => {
                    next()
                },
                opacity: 0
            })
        } else {
            next()
        }
    },
    methods: {
        hasOnceDrag: function(){
            if(!this.hasOnceDragged){
                this.hasOnceDragged = true
            }
        },
    },
    mounted: function(){


        Utils.fetch("/contact").then(res => {

            let isMobile = this.$root.mobileDetected

            this.contacts = {
                  links: [
                        {label: res.adresse, href: res.adresselink, type: "external"},
                        {label: res.mail, href: res.mail, type: "mail"},
                        {label: res.phone, href: res.phone, type: "phone"},
                        {label: "instagram", href: res.instagram, type: "external"},
                    ],
                    members: res.chilren.map(c => ({
                        fullname: c.title, 
                        job: c.contactposition, 
                        mail: c.contactmail
                    }))
            }

            this.scene = new SceneContact(this.$refs["canvas-container"], {
                
            }, {
                contacts: this.contacts,
                mobileDetected: isMobile,
                disableRaycaster: isMobile,
                hasOnceDrag: this.hasOnceDrag
            })
            this.scene.init()
            this.scene.start()

            // wait ressources
            MyEmitter.emit(params.Events.appHasLoadedRessources)
        })
    }
}
</script>

<style lang="scss">
    .page-contact{
        overflow: auto;

        &__credit{
            position: absolute;
            bottom: 25px;
            right: 25px;
            opacity: .3;
            font-size: 11px;
            text-transform: uppercase;
            transition: ease opacity 150ms;

            &:hover{
                opacity: 1
            }

            span{
                font-weight: bold;
            }
        }

        .image__drag-and-drop{
            width: 150px;
            position: absolute;
            bottom: 45px;
            left: 50%;
            transform: translate(-50%, 0);
            opacity: .5;
            transition: opacity ease 500ms;

            &.hide{
                opacity: 0;
            }

            .cls-1{
                fill: #fff
            }
        }

        &__track{
            position: relative;
            min-height: 100%
        }

        &-canvas-container{
            @include absolute-fullscreen();
            z-index: 0;
        }
        
        @include desktop{
            &-nav, &-body{
                display: none;
            }
        }

        &-nav{
            @include fixed-top();
            z-index: 1;
            padding: 33px;
            display: flex;
            justify-content: space-between;
            text-transform: uppercase;

            &-title{
                letter-spacing: 4px;
                font-weight: 700;
                font-size: ptToPx(16);
                
                @include very-small{
                    font-size: ptToPx(12);
                }
            }

            &-goback{
                font-size: ptToPx(16);
                letter-spacing: 4px;

                @include very-small{
                    font-size: ptToPx(12);
                }
            }

            @include very-small{
                padding: 22px;
            }
        }

        &-body{
            position: relative;
            top: calc(100vh - 155px);
            padding: 0 20px;
            padding-bottom: 220px;
                        
            &-links{
                text-align: center;
                margin-bottom: 62px;
                
                &-item{
                    margin-bottom: 23px;

                    @include very-small{
                        margin-bottom: 13px;
                    }

                    &:last-child{
                        margin-bottom: 0;
                    }

                    &-link{
                        text-transform: uppercase;
                        font-family: $font-title;
                        font-weight: 700;
                        font-size: ptToPx(23);

                        @include very-small{
                            font-size: ptToPx(16);
                        }
                    }
                }
            }

            &-members{
                text-align: center;

                &-item{
                    margin-bottom: 50px;
                    text-transform: uppercase;

                    &:last-child{
                        margin-bottom: 0;
                    }

                    &-fullname, &-job, &-mail{
                        font-size: ptToPx(16);

                        @include very-small{
                            font-size: ptToPx(12)
                        }
                    }

                    &-fullname{
                        font-family: $font-title;
                        font-weight: 700;
                        margin-bottom: 10px;

                        @include very-small{
                            margin-bottom: 5px;
                        }
                    }

                    &-job{
                        font-family: $font-title;
                        font-weight: 200;
                        margin-bottom: 15px;

                        @include very-small{
                            margin-bottom: 10px;
                        }
                    }

                    &-mail{
                        font-weight: 700;
                    }
                }
            }

            &-credit{
                display: inline-block;
                text-align: center;
                font-size: ptToPx(14);
                text-transform: uppercase;
                opacity: .3;
                position: absolute;
                bottom: 25px;
                left: 0;
                width: 100%;


                span{
                    font-weight: bold;
                }

                @include very-small{
                    font-size: ptToPx(12)
                }
            }
        }
    }
</style>